module.exports = __webpack_public_path__ + "UX23.png?116a2df1e3cd81c51083964c68750940";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX23.png
// module id = 73
// module chunks = 0